import { useSeo } from "@/hooks/useSeo";
import { PageHero } from "@/components/layout/PageHero";
import { StaggerGroup, StaggerItem } from "@/components/motion/Reveal";
import { Icon } from "@/components/Icon";
import { CtaBand } from "@/components/layout/CtaBand";
import { IMAGES, CAPABILITIES_CARDS } from "@/data/content";

export default function Capabilities() {
  useSeo({
    title: "Capabilities",
    description:
      "Scalable procurement and sourcing solutions — government procurement, strategic sourcing, logistics support, contract management, and commercial product acquisition.",
    path: "/capabilities",
    breadcrumb: [{ name: "Home", path: "/" }, { name: "Capabilities", path: "/capabilities" }],
  });

  return (
    <>
      <PageHero
        eyebrow="What We Do"
        titleLines={["Capabilities"]}
        subtitle="Meridian Vanguard Solutions provides scalable procurement and sourcing solutions designed to support the operational needs of government organizations while maintaining compliance, efficiency, and exceptional service."
        image={IMAGES.warehouse}
        breadcrumb={[{ name: "Home", path: "/" }, { name: "Capabilities", path: "/capabilities" }]}
      />

      <section className="bg-white py-24 md:py-32">
        <div className="w-full max-w-7xl mx-auto px-6 md:px-10">
          <StaggerGroup stagger={0.05} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {CAPABILITIES_CARDS.map((c) => (
              <StaggerItem key={c.title}>
                <div
                  data-testid={`capability-card-${c.title.toLowerCase().replace(/\s+/g, "-")}`}
                  className="group h-full flex flex-col rounded-xl border border-hairline bg-white p-8 transition-all duration-300 hover:-translate-y-1 hover:border-navy/20 hover:shadow-[0_18px_40px_rgba(10,35,66,0.10)]"
                >
                  <div className="h-14 w-14 rounded-xl bg-lightgray flex items-center justify-center transition-colors group-hover:bg-navy">
                    <Icon name={c.icon} className="h-7 w-7 text-navy transition-colors group-hover:text-white" />
                  </div>
                  <h3 className="mt-6 font-heading text-xl font-semibold text-navy">{c.title}</h3>
                  <p className="mt-3 text-steel leading-relaxed text-[15px]">{c.desc}</p>
                </div>
              </StaggerItem>
            ))}
          </StaggerGroup>
        </div>
      </section>

      <CtaBand
        title="Ready to discuss your requirements?"
        text="Tell us about your procurement needs and we'll outline how Meridian Vanguard Solutions can support your mission with dependable sourcing and delivery."
      />
    </>
  );
}
